import { BehaviorSubject, Observable} from 'rxjs';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { throwError, TimeoutError } from 'rxjs';

import { timeout, catchError, map, retry, first} from 'rxjs/operators';
import { Injectable }     from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { Router }         from '@angular/router';
//import { first , retry}          from 'rxjs/operators';
//import { JwtHelper }      from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Credentials, User, Scope, Ops }    from '../../_models/index';
import { environment }       from '../../../environments/environment';
//import { Http, Response, 
//        Headers, RequestOptions }   from '@angular/http';
import * as CryptoJS      from 'crypto-js';
//import { NgFlashService } from 'ng-flash';
//import { AngularFireAuth } from '@angular/fire/auth';
//import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { inject }     from '@angular/core';

//import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
//import { provideFirestore, getFirestore } from '@angular/fire/firestore';
//import { provideAuth, getAuth } from '@angular/fire/auth';
//import { Auth } from '@angular/fire/auth';
//import { signInWithCustomToken } from '@angular/fire/auth';

import { AngularFirestore }    from '@angular/fire/compat/firestore';
import { AngularFireAuth }     from '@angular/fire/compat/auth';

import { FS_REFRESHSTATUS, Refreshpagestatus, Referraltype }                       from '../../_models/index';
import { ENTITYREFERENCEMASTER_REFID }         from '../../_models/constants';

@Injectable()
export class AuthService {
  //dataCollection: AngularFirestoreCollection<Refreshpagestatus>;
  //private firestore: Firestore = inject(Firestore);
  //private firebaseAuth: Auth   = inject(Auth);
  dataCollection: Observable<any[]>;
  aCollection;
  public user: Observable<User>;  private currentUserSubject: BehaviorSubject<User>;
  public currentListReferralTypes: Observable<Referraltype[]>;  private currentListReferralTypesSubject: BehaviorSubject<Referraltype[]>;
  public currentAuthPoints: Observable<number>;  private currentAuthPointsSubject: BehaviorSubject<number>;
  //public id_token: string;
  private points:number = -10001;
  //public listReferralTypes  = [];
  constructor(
    private firestore: AngularFirestore,
    private firebaseAuth: AngularFireAuth,
    //private firebaseAuth = inject(getAuth),
    private httpClient: HttpClient, 
    private jwtHelperService: JwtHelperService, 
    private router: Router)
    //private _ngFlashService: NgFlashService) 
    {
      
      this.aCollection = this.firestore.collection('Refreshpagestatus');
      this.dataCollection = this.aCollection.valueChanges({ idField: 'id' });
      //this.aCollection = collection(this.firestore, 'Refreshpagestatus'); // Equivalent to AngularFirestoreCollection
      //this.dataCollection = collectionData(this.aCollection, { idField: 'id' }); // Equivalent to valueChanges()

      //this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_ent'))));
      //this.currentListReferralTypesSubject = new BehaviorSubject<Referraltype[]>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entref'))));
      //this.currentAuthPointsSubject = new BehaviorSubject<number>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entpts'))));

      this.currentUserSubject = new BehaviorSubject<User>(
        this.safeParse('onreference_ent', null)
      );

      this.currentListReferralTypesSubject = new BehaviorSubject<Referraltype[]>(
        this.safeParse('onreference_entref', []) || []
      );

      this.currentAuthPointsSubject = new BehaviorSubject<number>(
        this.safeParse('onreference_entpts', 0) || 0
      );

      this.user = this.currentUserSubject.asObservable();       
      this.currentListReferralTypes = this.currentListReferralTypesSubject.asObservable();
      this.currentAuthPoints = this.currentAuthPointsSubject.asObservable();
    }
  public get currentUserValue(): Required<User> {
      return {
        id_token: '',
        entityid: '',
        email: '',
        prefix: '',
        firstname: '',
        lastname: '',
        password: '',
        phone: '',
        scope: Scope.BF_ENT,
        firebasetoken: '',
        ...this.currentUserSubject.value
      };
  }
  public get getListReferralTypes(): Referraltype[] {
    return this.currentListReferralTypesSubject.value;
  }

  public get currentPoints(): number {
    return this.currentAuthPointsSubject.value;
  }

  public referralUrl = environment.gdocsurl;
  public apiUrl = environment.apiurl;
  public showLang = environment.showLang;

  public login(credentials: Credentials): Observable<any> {
      //this.user = { id: '', email:'',  scope: '', firstname: '', prefix: '', lastname: '' };
      this.resetSessionStorage();      
      var pwd =  CryptoJS.MD5(credentials.password) + "";      
      //var credData = JSON.parse('{"email":"'+credentials.email+'", "scope":"'+credentials.scope+'", "password":"'+pwd+'"}');
      var credData = {
        email: credentials.email?.toLowerCase().trim(),
        scope: credentials.scope,
        password: pwd
      };

      //var tmpset = this.setConstantListReferralTypes();
      //credentials.password =  "";
      //alert('md5: '+credentials.password);
      switch (credentials.scope){
        case Scope.BF_ENT:
          var url = this.apiUrl +  'login/entity/cred';
          const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
          //return this.httpClient.post(url, credData, {headers}).pipe(
          return this.httpClient.post(url, credData, { headers }).pipe(
          timeout(15000), // 15 second client-side timeout
          map((response:any)   => { //console.log('Got Reponse '+JSON.stringify(response));
                //console.log('id_token value:', response.id_token);  // <-- add this
                //console.log('id_token type:', typeof response.id_token);
                const data = response;                 
                if (data?.id_token){
                    //var user1 ={ id_token:'', id: '',  email:'', prefix: '', scope: '', firstname: '',  lastname: '', firebasetoken:'' };
                    var user1: User = {} as User;
                    user1.id_token = data.id_token;
                    user1.email = data.email?.toLowerCase().trim() ?? '';
                    user1.prefix = data.prefix ?? '';
                    user1.firstname = data.firstname ?? '';
                    user1.lastname = data.lastname ?? '';
                    user1.scope = String(data.entitytype) as Scope;
                    user1.entityid = data.entityid ?? '';
                    user1.firebasetoken = data.firebasetoken ?? '';
                    const scope = user1.scope as Scope;
                    switch (scope){
                      case Scope.BF_ENT:
                          //console.log('Setting onreference_ent');        
                          //console.log('About to store user1:', JSON.stringify(user1));
                          //console.log('id_token present:', user1?.id_token ? 'YES' : 'NO');                                          
                          sessionStorage.setItem('onreference_ent', this.b64EncodeUnicode(JSON.stringify(user1)));
                          break;
                      default:
                        console.log('In Scope default:'+user1.scope);
                        this.logout;
                    }
                    this.currentUserSubject.next(user1);
                    var tmplistref = this.setListReferralTypes(false);

                    var userfirebase = this.firebaselogin(user1.firebasetoken!)
                      //.then(cred => { })
                      .catch(err => { console.log("Firebase login failed: ", err); });
                    var tmpset = this.setConstantListReferralTypes();
                    //signInWithCustomToken(this.firebaseAuth, user1.firebasetoken);
                    //console.log("auth result:",this.firebaseAuth.user.toPromise.toString)
                    return {"success":true, "message": "", "response":response}; 
                }else{
                  if (response.statusCode != undefined &&  response.statusCode == '412'){console.log('Not activated.')
                    return {"success":false, "message": "Email is not activated. Please go to <a href='https://dev.onreference.com/us/ind-forgot-password'>Reset your password</a> and click on the email link that is received.", "response":response};
                  }
                  if (response.entityvalidated !== 'validated' ){
                    //this._flashMessagesService.show('User is not activated. Please check your email for activation email or click on Reset Your Password.', { cssClass: 'alert-success', timeout: 10000 });
                    //this._ngFlashService.success('User is not activated. Please check your email for activation email or click on Reset Your Password.');
                    console.log("User is not activated. Please check your email for activation email or click on Reset Your Password.");
                    return {"success":false, "message": "User is not activated. Please go to <a href='https://dev.onreference.com/us/ind-forgot-password'>Reset your password</a> and click on the email link that is received.", "response":response};
                  }else{
                    //{"err": true,"wait": 52}
                    const wait = response.wait ?? response.result?.wait ?? 0;
                    if (wait > 0) {
                      console.log('Please wait for '+wait+' seconds');
                    }
                    //return false;
                    return {"success":false, "message": wait > 0 ? "Please wait for "+wait+" seconds" : "Login temporarily unavailable. Please try again.", "response":response};
                  }
                }
              //}else{
              //  return false;
              //}
          }),
          //catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+JSON.stringify(err)) ),
          catchError((err: any, caught: Observable<any>) => {
            if (err instanceof TimeoutError) {
              return throwError(() => ({ message: 'Request timed out. Please try again.' }));
            }
            if (err?.status === 504) {
              return throwError(() => ({ message: 'Server is temporarily unavailable (504). Please try again shortly.' }));
            }
            return throwError(() => err ?? 'Server error');
          }),
        );
      }
      return throwError(() => new Error('Unsupported login scope'));
  };

async firebaselogin(firebasetoken: string){
  const currentFirebaseUser = await this.firebaseAuth.currentUser;
  if (currentFirebaseUser) {
    return currentFirebaseUser;
  }
  if (!firebasetoken || firebasetoken.split('.').length !== 3) {
    throw new Error('Missing or invalid Firebase custom token');
  }
  return await this.firebaseAuth.signInWithCustomToken(firebasetoken);
}

/*async firebaselogout(){
  return await this.firebaseAuth.signOut();
}*/

/*async firebaseDeleteToken(){
  console.log('Deleting: '+FS_REFRESHSTATUS+"/"+this.currentUserValue.id_token);
  return await this.firestore.collection(FS_REFRESHSTATUS).doc(this.currentUserValue.id_token).delete();
}*/

public loggedIn() {
    return this.authenticated();
};


public authenticated() {//alert('In authenticated')
  //console.log('authenticated() called');
   try{

      //var user = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_ent')));   
      var user = this.safeParse('onreference_ent',null);

      if (!this.jwtHelperService.isTokenExpired(user.id_token,15)){
        var decode = this.jwtHelperService.decodeToken(user.id_token); //alert('jwt Decode:'+JSON.stringify(decode));
        const scope = String(decode.scope) as Scope;        
        switch (scope){
          case Scope.BF_ENT:
              //this.user = { id_token:'', id: '',  email:'', prefix: '', scope: '', firstname: '',  lastname: '' };
              this.currentUserSubject.next(user);
              return true && this.currentUserValue;
          default:
            console.log('scope not recognized:', scope);
            this.logout;
            return false;
        }        
      }
   }catch(e){//alert('logout: '+JSON.stringify(e))
        this.logout;
        return false;     
   }
   return false;
 };

 

 public logout() {//alert('logout')
    //Delete the token data on cloud 
    //var userfirebase = this.firebaseDeleteToken().then(  ret => console.log("Deleted refresh token"));
console.trace('LOGOUT CALLED FROM:');     
    this.aCollection.doc(this.currentUserValue.id_token).delete().then(  ret => console.log("Deleted refresh token") ).catch(e => console.log("Error deleting refresh token: ",e));  

    /*var tmpdoc = this.firestore.collection(FS_REFRESHSTATUS).doc(this.currentUserValue.id_token);    
    if (tmpdoc){
      tmpdoc.delete();
    }*/
    this.firebaseAuth.signOut().catch(e => console.log("Firebase sign out failed: ", e));
    this.resetSessionStorage();
    var user:User = {}; 
    this.currentUserSubject.next(user);
    this.currentListReferralTypesSubject.next([]);
    this.currentAuthPointsSubject.next(0);
    console.trace('NAVIGATE TO IND-LOGIN FROM:');
    this.router.navigate(["/ind-login"]);
 };

 private resetSessionStorage(){
 // Remove token from sessionStorage
    try{
          sessionStorage.removeItem('onreference_org');
          sessionStorage.removeItem('onreference_orgref');          

          sessionStorage.removeItem('onreference_ent');
          sessionStorage.removeItem('onreference_entref');          

          sessionStorage.removeItem('onreference_adm');

          sessionStorage.removeItem('onreference_entpts');
          sessionStorage.removeItem('onreference_orgpts'); 
          
          sessionStorage.removeItem('onreference_reuse_ind-home');
          sessionStorage.removeItem('onreference_reuse_org-home');          

    }catch(e) {
    }
}

 /*private setSessionStorage(data){
    if (this.isSessionStorageNameSupported() === false){
      //this._flashMessagesService.show('Please disable "Private Mode", or upgrade to a modern browser.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');
      this._ngFlashService.success('Please disable "Private Mode", or upgrade to a modern browser.');
      return false; 
    }
    //this.id_token = data.id_token;
    //this.user.id = data.id;
    //this.user.id_token = data.id_token;
    //this.user.prefix = (data.prefix !== undefined) ? data.prefix : "" ;    
    //this.user.firstname = (data.firstname !== undefined) ? data.firstname : "" ;
    //this.user.lastname = (data.firstname !== undefined) ? data.lastname : "" ;
    //this.user.scope = data.scope; 
    //alert("Data scope: "+data.scope+" Scope.BF_ENT: "+Scope.BF_ENT);
    try{
      switch (parseInt(data.scope)){
        case Scope.BF_ENT:
          try{
            
              sessionStorage.setItem('onreference_ent', this.b64EncodeUnicode(JSON.stringify(this.user)));
              return true;
          }catch(e) {
            //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
            this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
          }
        default:
          this.logout;
          return false;
      }   
    }catch(e){
      if (this.isSessionStorageNameSupported() === false){
        //this._flashMessagesService.show('Please disable "Private Mode", or upgrade to a modern browser.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');
        this._ngFlashService.success('Please use modern browser or disable private mode.');
        return false; 
      }else{
        //this._flashMessagesService.show('Error: Please close tab and login again.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');        
        this._ngFlashService.success('Error: Please close tab and login again.');
        return false;        
      }
  
    } 
 }*/

 public setConstantListReferralTypes(){
    /*var tmp:Referraltype[] = [];
    //let tmp: any[] = [];
    for (var i in ENTITYREFERENCEMASTER_REFID){
      tmp.push(ENTITYREFERENCEMASTER_REFID[i]);
    }*/
    //console.log("Setting onreference_entref: ",ENTITYREFERENCEMASTER_REFID);
    sessionStorage.setItem('onreference_entref', this.b64EncodeUnicode(JSON.stringify(ENTITYREFERENCEMASTER_REFID)));
    this.currentListReferralTypesSubject.next(ENTITYREFERENCEMASTER_REFID);
    sessionStorage.setItem('onreference_entpts', this.b64EncodeUnicode(JSON.stringify(this.points)));
    this.currentAuthPointsSubject.next(this.points);
    return true;
 }
  public setListReferralTypes(force){
   try{
      var tmplist = this.setConstantListReferralTypes();
      var tmplistReferralTypes:Referraltype[] = [];
      //var user = (this.user != undefined) ? this.user : this.b64DecodeUnicode(sessionStorage.getItem('onreference_ent'));
      var user = this.currentUserValue; //console.log("In setListReferralTypes"+user.id_token);
      var decode = this.jwtHelperService.decodeToken(user.id_token); //console.log('Decode scope-'+decode.scope);
      const scope = String(decode.scope) as Scope;;
      switch (scope){
        case Scope.BF_ENT:  //console.log("In switch setListReferalTypes");
          if (!this.jwtHelperService.isTokenExpired(user.id_token,15)){
              return this.getSetReferralTypes(user.id_token, scope).pipe(first()).subscribe((data:any) => {
                //console.log('in getreferaltypes subscribe'+JSON.stringify(data));
                var obj = data;//JSON.parse(JSON.stringify(data));
                var res200 = (data.status == "200") ? true: (data.errorcode);
                if (res200 === true){
                  //this.listReferralTypes = [];
                  for (var i in data.result){//alert('objresult: '+data.result[i].referenceid);
                    if (i == "entpoints"){
                      try{
                        sessionStorage.setItem('onreference_entpts', this.b64EncodeUnicode(JSON.stringify(parseInt(data.result[i]))));
                        this.points = parseInt(data.result[i]);//console.log('Data.result: ', data.result[i]);
                        this.currentAuthPointsSubject.next(this.points);
                      }catch(e) {
                        //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
                        //this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
                      }
                    }else{
                      //this.listReferralTypes.push(data.result[i]);
                      tmplistReferralTypes.push(data.result[i]);
                    }
                  }
                  try{
                    ////console.log('Setting onreference_entref full: ',tmplistReferralTypes);
                    sessionStorage.setItem('onreference_entref', this.b64EncodeUnicode(JSON.stringify(tmplistReferralTypes)));
                    var tmp1:Referraltype[] = [];
                    for (var i in tmplistReferralTypes){
                      tmp1.push(tmplistReferralTypes[i]);
                    }
                    this.currentListReferralTypesSubject.next(tmp1);
                    //console.log('DOne with currentListReferralTypes: ',tmp1);
                  }catch(e) {
                    //this._flashMessagesService.show('Could not set reference types. Please logout and login.', { cssClass: 'alert-success', timeout: 10000 });//alert('Could not set reference types. Please logout and login.');
                    //this._ngFlashService.success('Could not set reference types. Please logout and login.');
                    this.logout;
                    return false;
                  }
                  return true;
                }else{
                  //this._flashMessagesService.show('Error in getReferencemaster-'+JSON.stringify(res200), { cssClass: 'alert-success', timeout: 10000 });//alert('Error in getReferencemaster-'+JSON.stringify(res200));
                }
                this.logout;
                return false;
              });
          }
        default:
          this.logout;
          return false;
      }
   }catch(e){
        this.logout;
        return false;     
   }

}
private getSetReferralTypes(id_token,scope){
        //var body = '{ "id_token":"'+this.id_token+'", "ops":"4", "scope":"3" , "entid":"'+this.user.id+'" }';
        //var body = '{ "id_token":"'+id_token+'", "ops":"'+Ops.GETREFERRALTYPES+'", "scope":"'+decode.scope+'" , "entid":"'+decode.id+'" }';
        //var body = '{ "id_token":"'+id_token+'", "ops":"'+Ops.GETREFERRALTYPES+'" ,  "scope":"'+parseInt(decode.scope)+'" }';        
        var body = {id_token:'', ops: '',  scope: ''};
        body.id_token = (id_token !== undefined) ? id_token : "";
        body.ops = (Ops.GETREFERRALTYPES.toString() !== undefined) ? Ops.GETREFERRALTYPES.toString() : "";
        body.scope = (scope !== undefined) ? scope : "";
        //console.log('Before getSetReferralTypes post Body:'+JSON.stringify(body));
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.post(this.referralUrl, body, {headers}).pipe(
        return this.httpClient.post(this.referralUrl, body, {headers}).pipe(
        //retry(3),
        map((res:any) => {//console.log('Got referraltypes map:'+JSON.stringify(res));
          //console.log('Raw response:', JSON.stringify(res), typeof res);
          return res;//return res.json();
        }),
        //catchError((err:any, caught: Observable<any>) => ErrorObservable.create((err) ? (err) : 'Server error: '+err.text()) ),)
        catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err) ),)
}

/*public getListReferralTypes(){
  //return  (this.listReferralTypes != undefined && this.listReferralTypes.length > 0) ? this.listReferralTypes : this.setListReferralTypes(false) ;  
  if  (this.listReferralTypes != undefined && this.listReferralTypes.length > 0) {
    return this.listReferralTypes;
  }
  
  try{               
    this.listReferralTypes = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entref')));
  }catch(e) {      
    this.setListReferralTypes(false);
    this.listReferralTypes = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entref')));
    //this._flashMessagesService.show('Refreshing points.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
  }                              

  return this.listReferralTypes;  
}*/

public getPoints(force){
  if (force){
    this.setListReferralTypes(true);
  }else{
    if  (this.currentPoints != undefined && this.currentPoints != -10001) {
      return this.currentPoints;
    }else{
      return 0;
    }
  }
  return this.currentPoints;

  /*try{        
    this.points = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entpts')));
  }catch(e) {      
    this.setListReferralTypes(true);
    this.points = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_entpts')));
    //this._flashMessagesService.show('Refreshing points.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
  }
  return this.points;                */

}

public updatePoints(points){
  
  try{                                
    sessionStorage.setItem('onreference_entpts', this.b64EncodeUnicode(JSON.stringify(points)));
    this.currentAuthPointsSubject.next(points);
  }catch(e) {
    //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
    //this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
  }                              
}

/*private isSessionStorageNameSupported() { 
    var testKey = 'test';
    try {
      sessionStorage.setItem(testKey, '1');
      sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }*/

   private b64EncodeUnicode(str: string) {
    try{
     var words = CryptoJS.enc.Utf8.parse(str);
     return CryptoJS.enc.Base64.stringify(words)
    }catch (e){
      return "";
    }
    /*return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
   }))*/
  }

   /*public b64DecodeUnicode(base64) {
    if (base64 === null){ return null};
    try{
      var words = CryptoJS.enc.Base64.parse(base64);
      return CryptoJS.enc.Utf8.stringify(words);
    }catch(e){
      return "";
    }
    //return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    //    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    //}).join(''));
  }*/

  public b64DecodeUnicode(base64: string) {
    try {
      if (!base64) return null;
      const words = CryptoJS.enc.Base64.parse(base64);
      return CryptoJS.enc.Utf8.stringify(words);
    } catch (e) {
      console.error('Base64 decode failed:', e);
      return null;
    }
  }
  

  private getHeaderOptions(id_token){
    // //let headers = new Headers();
    //headers.append('Content-Type', 'text/plain');
    //headers.append('Authorization', id_token);
    //headers.append('Access-Control-Allow-Origin', 'https://script.googleusercontent.com');
    //headers.append('Access-Control-Allow-Origin', '*');
    // //return new RequestOptions({ headers: headers });
    if (id_token){
      var httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          //'Content-Type':  'text/plain',
          Authorization: id_token
        })
      };
    }else{
      var httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          //'Content-Type':  'text/plain',
          //Authorization: id_token
        })
      };
    }
      return httpOptions;
  }

  private safeParse(key: string, fallback: any) {
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return fallback;

      const decoded = this.b64DecodeUnicode(raw);
      if (!decoded) return fallback;

      return JSON.parse(decoded);
    } catch (e) {
      console.error(`Error parsing ${key}:`, e);
      return fallback;
    }
  }

}
